import { triggerEvent } from './analytics';

const getSrc = video => video.attr('src') || '';

const videoPause = payload => {
	triggerEvent('video', 'pause', getSrc(payload.element));
};

const videoPlay = payload => {
	triggerEvent('video', 'play', getSrc(payload.element));
};

export default {
	play: videoPlay,
	pause: videoPause,
};
